export default "__VITE_ASSET__3b94ce6a__"